import {
  LABEL_WIDTH,
  SectionContainer,
} from 'features/indicationTriage/cards/ffsCalc/FfsCalcLayout'
import { FfsParameterField } from 'features/indicationTriage/cards/ffsCalc/FfsParameterField'
import { FfsSharedValuesContext } from 'features/indicationTriage/cards/ffsCalc/FfsSharedValues'
import React, { FC, useContext } from 'react'
import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

export const LABEL_FCA_ML = (
  <>
    FCA<sub>ml</sub>
  </>
)

const RawFfsUserInputSection: FC<object> = () => {
  const { fca, setFca, fcaMl, setFcaMl } = useContext(FfsSharedValuesContext)
  return (
    <SectionContainer>
      <FfsParameterField
        label='FCA'
        labelTooltip='Future Corrosion Allowance'
        labelWidth={LABEL_WIDTH}
        value={fca}
        setValue={setFca}
        min={GeckoMeasurement.CreateFromValue(
          0,
          GeckoMeasurementUnit.Millimeters
        )}
        step={0.1}
      />
      <FfsParameterField
        label={LABEL_FCA_ML}
        labelTooltip='FCA in region of metal loss'
        labelWidth={LABEL_WIDTH}
        value={fcaMl}
        setValue={setFcaMl}
        min={GeckoMeasurement.CreateFromValue(
          0,
          GeckoMeasurementUnit.Millimeters
        )}
        step={0.1}
      />
    </SectionContainer>
  )
}

export const FfsUserInputSection = React.memo(RawFfsUserInputSection)
